export default __webpack_public_path__ + "static/media/jest.ef5db17e.png";